var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.hrefLink,"target":"_blank"},on:{"mouseenter":function($event){return _vm.changeCursorStyle(_vm.cursorHoverIconStyle)},"mouseleave":_vm.removeCursorStyle}},[_c('img',{staticClass:"w-10",attrs:{"src":_vm.imageSrc,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }